
export enum SendByEnum {
    Email= "4",
    PreComMsg="64"
}

